module.exports = __webpack_public_path__ + "static/img/30012 (3).b3317b0.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/30000/30012 (3).webp
// module id = tv/K
// module chunks = 14